import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './SlideIn.scss'

import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import PropTypes from 'prop-types'

const SlideIn = ({ children, from }) => {
	const enterClass = `enter-${from}`
	const activeClass = `enter-${from}-active`
	return (
		<CSSTransitionGroup
			transitionName={{
				enter: styles[enterClass],
				enterActive: styles[activeClass],
				appear: styles[enterClass],
				appearActive: styles[activeClass]
			}}
			transitionEnterTimeout={150}
			transitionLeave={false}
			transitionAppearTimeout={150}
			transitionAppear={true}
			styleName="wrapper"
		>
			{children}
		</CSSTransitionGroup>
	)
}

SlideIn.propTypes = {
	from: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	childern: PropTypes.element
}

export default CSSModules(SlideIn, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Transitions/SlideIn.js